export const IconPrintFb: {
  name: 'icon_print_fb-11525d565271'
} = {
  name: 'icon_print_fb-11525d565271'
}
